module.exports = {
  xs: "400px",
  "lg-tall": { raw: "(min-height: 900px) and (min-width: 1024px)" },
};
